<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">币安合约</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>交易记录、强平记录、全部挂单、所有订单</el-breadcrumb-item>
        </el-breadcrumb>

        <el-tabs v-model="activeName" style="margin-top: 10px;margin-bottom: 10px">
            <el-tab-pane label="交易记录" name="TRANSACTION_RECORD">
                <transaction-record></transaction-record>
            </el-tab-pane>
            <el-tab-pane label="强平记录" name="STRONG_LEVELING_RECORD">
                <strong-leveling-record></strong-leveling-record>
            </el-tab-pane>
            <el-tab-pane label="全部挂单" name="ALL_BILLS">
                <all-bills></all-bills>
            </el-tab-pane>
            <el-tab-pane label="所有订单" name="ALL_ORDER">
                <all-order></all-order>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import AllBills from './components/allBills';
    import AllOrder from './components/allOrder';
    import StrongLevelingRecord from './components/strongLevelingRecord';
    import TransactionRecord from './components/transactionRecord';

    export default {
        name: 'OrderRecord',
        components: {
            AllBills,
            AllOrder,
            StrongLevelingRecord,
            TransactionRecord
        },
        data() {
            return {
                activeName: "TRANSACTION_RECORD"
            }
        },
        methods: {
        },
        created() {

        }
    };
</script>

<style lang="less" scoped>

</style>

